<script>
  import config from '../../libs/config.json';
  import func from '../../libs/functions.js';
  import api from '../../api'
  import axios from 'axios'
  import _ from 'lodash'

  import { getPlatformImage } from './mixins/getPlatformImage'

  import tippy from 'tippy.js'

  import iziToast from 'izitoast'
  import 'izitoast/dist/css/iziToast.min.css';

  import _system from '../../libs/system';

	import { mapGetters, mapActions } from 'vuex'
  
  import system from '../../libs/system';
	
	export default 
	{
		name: 'team',
    mixins: [ getPlatformImage ],
		data() 
        {
        	return {
            func: func,
            search: '',
            activeAccounts: [],
            show: {
              teammateModal : false,
              assign: false
            },
            loading: {
              workspaces: true,
              workspaceusers: true,
              addTeammate: false,
              assignChannel: false
            },
            assign: {
              teammate:  {}
            },
            assignedAccounts: [],
            newTeammate: {
              name:'',
              email: '',
              tags: [],
              department: {
                name: 'Admin',
                _id: ''
              }
            }
        	}
        },
        computed: {
          ...mapGetters('session', ['isLoggedIn', 'getUser', 'getRole', 'getWhiteLabel']),
          ...mapGetters('networks', ['networksById']),
          ...mapGetters('workspaces', ['currentWorkspace','workspaces', 'workspacesById']),
          ...mapGetters('tags', ['tags', 'tagsByName', 'tagsByTypeName']),  
          ...mapGetters('workspaceusers', ['workspaceusers']),
          ...mapGetters('accounts', ['accounts']),
          filteredItems() {
            let filteredAccounts = this.pickAccounts.filter(item => {
              return item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
            })
            console.log(filteredAccounts);
            let latestSortedAccounts = _.orderBy(filteredAccounts, ['name']);
            return latestSortedAccounts;
          }
        },
      methods: {
        ...mapActions('session', ['setUser']),
        ...mapActions('workspaceusers', ['setWorkspaceusers']),
        orderByName(accounts){
          return _.orderBy(accounts, ['name']);
        },
        updateWorkspaceName(){

          if(this.currentWorkspace.name.length < 2) return alert('Type at least 2 character!');

          let payload = {
            query: {
              workspaceId: this.currentWorkspace._id
            },
            body: {
              name: this.currentWorkspace.name
            }
          }
          _system.services.workspaces.update(payload, (err, res) => {
            if(err) return alert(err.message);
                    iziToast.success({
                      position: 'bottomCenter',
                      title: 'Workspace name updated to: ' + this.currentWorkspace.name,
                  });
          })
        },
        setAccount(account){

          let teammate = this.assign.teammate;

          //if accoun iis already assigned then setBackIt!
          if(this.checkVisibility(account, 'account') == 'checked') return this.setBackAccount(account, teammate);

          this.loading.assignChannel = true;
          let payload = {
            query:{
              userId: teammate._id,
            },
            body: {
              pageId: account._id
            }
          }
          _system.services.workspaceusers.addAccount(payload, (err, teammate) => {
            if(err) return alert(err.message);

            let index = _.findIndex(this.workspaceusers, (user) => { return user._id == teammate._id });

/*             let index2 = _.findIndex(this.pickAccounts, { _id: account._id});
            this.pickAccounts[index2].checked = true; */

            let indexAccount = _.findIndex(this.activeAccounts, { _id: account._id});
            this.activeAccounts[indexAccount].checked = true;
            this.$set(this.activeAccounts, indexAccount, this.activeAccounts[indexAccount]);

            this.workspaceusers[index].pages = teammate.pages;
            this.setWorkspaceusers(this.workspaceusers);
          });

        },      
        setBackAccount(account){

        let teammate = this.assign.teammate;

        let payload = {
            query: {
              workspaceuserId: teammate._id,
              pageId: account._id
            }
          }
          _system.services.workspaceusers.deleteAccount(payload, (err, teammate) => {

            let index = _.findIndex(this.workspaceusers, (user) => { return user._id == teammate._id });

/*             let index2 = _.findIndex(this.pickAccounts, { _id: account._id});
            this.pickAccounts[index2].checked = false; */

            let indexAccount = _.findIndex(this.activeAccounts, { _id: account._id});
            this.activeAccounts[indexAccount].checked = false;
            this.$set(this.activeAccounts, indexAccount, this.activeAccounts[indexAccount]);


            this.workspaceusers[index].pages = teammate.pages;
            this.setWorkspaceusers(this.workspaceusers);

          });
        },
        setAssignableUser(teammate){

          if(this.checkVisibility(teammate, 'team') == 'checked') return this.setBackAssignableUser(teammate);

          let payload = {
            query: {
              workspaceuserId: this.assign.teammate._id
            },
            body: { 
              visibleUserId: teammate.user._id
            }
          }
          _system.services.workspaceusers.setVisible(payload, (err, workspaceUser) => {
            if(err) return alert(err.message);


          let workspaceUserIndex = _.findIndex(this.workspaceusers, (user) => { return user._id == teammate._id });

          this.workspaceusers[workspaceUserIndex].visibleUsers = workspaceUser.visibleUsers;
          this.assign.teammate.visibleUsers = workspaceUser.visibleUsers;
          this.setWorkspaceusers(this.workspaceusers);

          });
        },
        setBackAssignableUser(teammate){
          let payload = {
            query: {
              workspaceuserId: this.assign.teammate._id,
              visibleUserId: teammate.user._id
            }
          }
          _system.services.workspaceusers.deleteVisible(payload, (err, workspaceUser) => {
            if(err) return alert(err.message);


          let workspaceUserIndex = _.findIndex(this.workspaceusers, (user) => { return user._id == teammate._id });

          this.workspaceusers[workspaceUserIndex].visibleUsers = workspaceUser.visibleUsers;
          this.assign.teammate.visibleUsers = workspaceUser.visibleUsers;
          this.setWorkspaceusers(this.workspaceusers);

          });
        },
        checkVisibility(teammateOrAccount, type){
          if(type == 'team'){
            if(this.assign.teammate.visibleUsers && this.assign.teammate.visibleUsers.length && _.find(this.assign.teammate.visibleUsers, { _id: teammateOrAccount.user._id })){
              return 'checked'
            }else{
              return ''
            }
          }else{
            if(teammateOrAccount.checked){
              return 'checked'
            }else{
              return ''
            }
          }
        },
        assignEvent(teammate){
          //this.pickAccounts = Object.assign(this.pickAccounts, this.accounts);

          this.activeAccounts = _.filter(this.accounts, (account) => {
              if(account.tags && account.tags.indexOf(this.tagsByName['Passive']._id) == -1 || !account.tags){
                if(_.find(teammate.pages, {_id: account._id})){
                  account.checked = true;
                    return account;
                }else{
                  account.checked = false;
                    return account;
                }
              }
            });

/*           this.pickAccounts = _.map(this.pickAccounts, (account) => {
            if(_.find(teammate.pages, {_id: account._id})){
              account.checked = true;
              return account
            }else{
              return account
            }
          }) */

          this.assign.teammate = teammate;
          this.show.assign = true;

        },  
        deleteFromWorkspaceusers(workspaceuser){
          _system.services.workspaceusers.deleteWorkspaceUser({ workspaceuserId: workspaceuser._id }, (err, data) => {
                this.setWorkspaceusers(_.filter(this.workspaceusers, (workspace) => workspace._id != workspaceuser._id));
          })
        },
        resendEmail(user){
          let payload = {
            query: {
              userId: user.user._id,
            },
            body: {
              event: 'Resend Team Invitation Email'
            }
          }
          system.services.user.resendInvitation(payload, (err, res) => {
            if (err) return err
                  iziToast.success({
                      title: 'Invited email has been sent!',
                      message: 'Notification sent to ' + user.user.email
                  });
          })
        },
        addTeammate(){
          this.loading.addTeammate = true
          this.newTeammate.name = func.extractName(this.newTeammate.email);

          this.newTeammate.email = this.newTeammate.email.toLowerCase().trim();

          let payload = this.newTeammate;

          //payload.with = 'InvitationEmail';

          _system.services.user.create(payload, (err, data) => {
            if(err) {
              const payload = {
                query: {
                  email: this.newTeammate.email
                }
              }

              _system.services.user.getUserByEmail(payload, (err, user) => {
              let payload = {
                workspace: this.currentWorkspace._id,
                user:  user._id,
                tags :  [this.tagsByName[this.newTeammate.department.name]._id, this.tagsByName['Invited']._id],
              }
              
              if(this.newTeammate.department.name == 'Admin') payload.pages = _.map(this.accounts, '_id');

                _system.services.workspaceusers.addWith(payload, (err, workspaceusers) => {
                  if(err) {
                  iziToast.error({
                      title: 'This user already exists'
                  });
                      this.show.teammateModal = false;
                      this.loading.addTeammate = false
                  }else{
                    this.setWorkspaceusers(workspaceusers);
                    
/*                     console.log('identifyStart4ed1')
                      window.analytics.identify(user._id, {
                        id: user._id,
                        email: user.email
                      });

                      setTimeout(() => {
                          window.analytics.track('User Invited');
                      },6000)

                      setTimeout(() => {
                          window.analytics.identify(this.getUser._id, {
                            id: this.getUser._id,
                            email: this.getUser.email
                          });
                      },12000) */
                    
                  
                  iziToast.success({
                      title: 'Invited',
                      message: 'Notification sent to ' + this.newTeammate.email
                  });
                
                      this.show.teammateModal = false;
                      this.loading.addTeammate = false

                        // Reset
                        this.newTeammate = { name: '', email: '', department: { name: 'Admin', _id: this.tagsByName['Admin']._id } }
                
                  }})
              });
            }else{
            // 1 - Add the registered user into His/Her workspace 
              let payload1 = { "name":"Personal Workspace", tags: [this.tagsByName['Individual']._id] }
              _system.services.workspaces.create(payload1, (err, workspace) => {
                if (err) return alert(err.message);
                let payload2 = {                
                  query: {
                    email: this.newTeammate.email
                  }
                };
                _system.services.user.getUserByEmail(payload2, (err, user) => {
                  let payload3 = {
                    workspace: workspace._id,
                    user:  user._id,
                    tags :  [this.tagsByName['Admin']._id]
                  }
                  _system.services.workspaceusers.add(payload3, (err, data) => {
                    if (err) return alert(err.message);
                  });
              })
              })

              // 2 - Add the registered user into current workspace              
                let payload = {
                  workspace: this.currentWorkspace._id,
                  user:  data.user._id,
                  tags :  [this.tagsByName[this.newTeammate.department.name]._id, this.tagsByName['Invited']._id],
                }

                if(this.newTeammate.department.name == 'Admin') payload.pages = _.map(this.accounts, '_id');

                _system.services.workspaceusers.add(payload, (err, workspaceusers) => {
                  if(err) return alert(err.message);

                  this.setWorkspaceusers(workspaceusers);


                      //Password emaili tetikler
                      //gecici password set et
                      console.log('identifyStart4ed2')
/*                       window.analytics.identify(data.user._id, {
                        id: data.user._id,
                        email: data.user.email
                      });

                      setTimeout(() => {
                        window.analytics.track('User Invited', {
                          token: data.accessToken,
                          reset: 'true'
                        });
                      },6000)


                      setTimeout(() => {
                          window.analytics.identify(this.getUser._id, {
                            id: this.getUser._id,
                            email: this.getUser.email
                          });
                      },12000) */
                      //password emaili tetiklendi
              
                  iziToast.success({
                      title: 'Invited',
                      message: 'Invitation email sent to ' + this.newTeammate.email
                  });



                  this.show.teammateModal = false;
                  this.loading.addTeammate = false

                  // Reset
                  this.newTeammate = { name: '', email: '', department: { name: 'Admin', _id: this.tagsByName['Admin']._id } }
                })
              }
            })
        }
      },
      mounted() { 
        document.body.addEventListener('keyup', e => { if (e.keyCode === 27) { this.show.assign = false } }) 
          tippy('#editWs', {
            content: 'Click and Edit then Press Enter to Update',
            animation: 'shift-away'
          })
        },
      created(){
        console.log(this.getRole.name)
      }
	}
</script>

<template>

  <div class="ui grid stackable">

<div v-if="show.assign" id="scrollingContainer" class="modalWrapper">
<div @click="show.assign = false" class="modal"> </div>
<div style="margin-top: 15px;margin-bottom: 30px;"  class="ui container">
      <div  class="ui grid centered stackable">
        <div style="padding-top:0; padding-bottom:0; padding-right:0;" class="ten wide column" >
          <div  @click="show.assign = false"  class="ui basic segment right aligned">
            <a style="background: rgba(0,0,0,0.6); position:relative; z-index:999999" class="ui black mini button">Close [ESC]</a>
          </div>
        </div>
      </div>
  <div class="ui grid centered stackable">
        <div style="background: rgba(0,0,0,.06);z-index: 9999;border-radius: 10px;" class="ten wide column">
        <div class="ui grid">
        <div style="padding-bottom: 0;" class="row">
          <div class="sixteen wide column">
            <div style="background: #f5f5f5; border-bottom: 1px solid #e9e9e9; border-radius: 3px 3px 0 0;" class="ui basic segment">
                  <img style="background: #ddd;" :src="'https://www.gravatar.com/avatar/' + func.md5(assign.teammate.user.email) + '?d=monsterid'" class="ui avatar image">
                  <span style="vertical-align: middle;">
                    <span style="font-weight: bold; font-size: 16px;"> {{assign.teammate.user.name}} </span>
                    <span style="font-style: italic; font-size: 12px;"> {{assign.teammate.role.name}}, </span>
                    <span style="font-style: italic; font-size: 12px;"> {{assign.teammate.user.email}} </span>
                    <span v-if="assign.teammate.is_invited" style="float: right;margin-top: 4px;" class="ui yellow small label">Pending Request</span>
                  </span> 
            </div>
          </div>
        </div>
        <div style="padding-top:0;" class="row">
          <div style="padding-right:0;" class="eight wide computer sixteen wide mobile column">
            <div style="background: #f5f5f5; height:100%;" class="ui basic segment">
              <h4>Channels</h4>

              <div v-for="account in orderByName(activeAccounts)" :key="account._id" @click="setAccount(account)" class="checkboxInput">
                <div :class="(account.checked) ? 'checked' : '' " class="checkbox">
                  <i class="icon-check check icon"></i>
                </div>
                <div style="position: relative;" class="checkboxLabel">
                  <img style="margin-right: 4px; width: 22px; border-radius: 22px; vertical-align: middle;" :src="account.avatar"> 
                    <img :src="getPlatformImage(account.platform)" style="bottom: -4px;width: 14px;height: 14px;border-radius: 20px;vertical-align: middle;position: absolute;left: -4px;border: 1px solid #fff;" alt="">
                    <span style="display: inline-block;">{{account.name}}</span>
                  </div>
              </div>
              
            </div>
          </div>
          <div style="padding-left: 0; border-left: 1px solid #e9e9e9;" class="eight wide computer sixteen wide mobile column">
            <div style="background: #f5f5f5; height:100%;" class="ui basic segment">
              <div  v-if="getRole.name == 'Admin' && assign.teammate.role.name != 'Moderator'" style="position: absolute; z-index: 99999999999; background: #f1f1f1; top: 0; bottom: 0; right: 0; left: 0;"></div>
              <h4>Assignable Teammates</h4>
              <div v-for="teammate in workspaceusers" :key="teammate.user._id" @click="setAssignableUser(teammate)" class="checkboxInput">
                <div :class="checkVisibility(teammate, 'team')" class="checkbox">
                  <i class="icon-check check icon"></i>
                </div>
                <div class="checkboxLabel"> <img style="margin-right: 4px; width: 22px; border-radius: 22px; vertical-align: middle;" :src="'https://www.gravatar.com/avatar/' + func.md5(teammate.user.email) + '?d=monsterid'"> <span style="display: inline-block;">{{teammate.user.name}}</span></div>
              </div>
            </div>
          </div>
        </div>
        </div>
        </div>
    </div>
    </div>
    </div>

<!--             <div style="border: none;box-shadow: 0 0 40px #777;" class="ui segments">
              <div class="ui segment">
                <div style="margin:-1rem; border: none; box-shadow: none;" class="ui segments">
                  <div class="ui segment">
                  <img style="background: #ddd;" :src="'/img/avatar/roboto/128/latin_'+ func.getFirstLetter(assign.teammate.user.name) +'.png'" class="ui avatar image">
                  <span style="vertical-align: middle;">
                    <span style="font-weight: bold; font-size: 16px;"> {{assign.teammate.user.name}} </span>
                    <span style="font-style: italic; font-size: 12px;"> {{assign.teammate.role.name}}, </span>
                    <span style="font-style: italic; font-size: 12px;"> {{assign.teammate.user.email}} </span>
                    <span v-if="assign.teammate.is_invited" style="float: right;margin-top: 4px;" class="ui yellow small label">Pending Request</span>
                  </span> 
                  </div>
                  <div style="color: #ddd;border-top: 1px solid #f1f1f1;" class="ui segment left aligned"> 
                    <h5 v-if="assign.teammate.pages && assign.teammate.pages.length">Assigned</h5>
                    <p v-if="!assign.teammate.pages" style="text-align: center;"><i class="info icon"></i>  <b>Assign from the list below</b></p>
                    <span v-if="assign.teammate.pages">
                    <a  v-for="assignedAccount in assign.teammate.pages" :key="assignedAccount._id" style="margin-bottom: 5px;" class="ui image label">
                        <img :src="assignedAccount.avatar">
                        <i style="margin-right: 5px;" :class="networksById[assignedAccount.platform].name.toLowerCase() +' icon'"></i>
                        {{assignedAccount.name}}
                        <i @click="assignBackAccount(assignedAccount, assign.teammate)" class="close icon"></i>
                    </a>   
                  </span>       
                  </div>        
                </div>

              </div>
              <div v-if="accounts.length > 10" style="border-top: 1px solid #f1f1f1; padding: 0;" class="ui segment">
                    <div class="ui fluid input">
                      <input style="border:none; " v-model="search" type="text" placeholder="Search...">
                    </div>                
              </div>
              <div v-if="pickAccounts.length" style="border-top: 1px solid rgb(248, 246, 246);" class="ui segment">
                <div v-if="pickAccounts.length" style="margin:-1rem; border: none; box-shadow: none;" class="ui segments">
                  <div :class="(loading.assignChannel) ? 'ui segment loading': 'ui segment'">
                    <h5>Channels</h5>
                      <a v-for="account in filteredItems" :key="account._id" @click="assignAccount(account, assign.teammate)" style="margin-bottom: 5px;" class="ui image label">
                          <img :src="account.avatar">
                        <i style="margin-right: 5px;" :class="networksById[account.platform].name.toLowerCase() +' icon'"></i> {{account.name}}
                      </a>      
                  </div>
                </div>
              </div>
            </div> -->


    <div v-if="!currentWorkspace" style="position: absolute; top: 50%;left:45%;">
        <span style="font-size: 26px;"> ⏳ loading . . . </span>
    </div>

    <div v-if="workspaceusers && currentWorkspace" class="fourteen wide computer sixteen wide mobile centered column">
      <div class="ui basic large segment ">
      <div class="ui basic large segment noTopPad">
        <h2> <img :style="{'background': '#f1f1f1','vertical-align' : 'middle'}" :src="'/img/avatar/roboto/128/latin_'+ func.getFirstLetter(currentWorkspace.name) +'.png'" class="ui avatar image"> <input id="editWs" v-on:keyup.enter="updateWorkspaceName()" title="Click here to Edit your workspace name" style="border:none; display: inline-block;background: transparent;" :style="'width:' +((currentWorkspace.name.length + 2) * 12)+'px'" v-model="currentWorkspace.name" onkeypress="this.style.width = ((this.value.length + 1) * 12) + 'px';" type="text"> <!-- <span class="workspaceName"> {{currentWorkspace.name}} </span> --> <span style="vertical-align: middle;" class="ui mini black label">{{currentWorkspace.pricingPlan}}</span></h2>


        <div v-if="!workspaceusers.length" class="ui basic segment center aligned">
          <div class="loader-inner ball-beat"><div></div><div></div><div></div></div>
        </div>
<div class="ui divider"></div>
<h3>Teammates</h3>
  <div v-for="teammate in workspaceusers" :key="teammate._id" style="border: none;background: #fff;" class="ui segments">
  <div v-if="teammate.user" class="ui horizontal segments">
    <div class="ui segment">
      <p>
      <img style="background: #ddd;" :src="'https://www.gravatar.com/avatar/' + func.md5(teammate.user.email) + '?d=monsterid'" class="ui avatar image">
      <span style="vertical-align: middle;">
        <span style="font-weight: bold; font-size: 16px;"> {{teammate.user.name}} </span>
        <span style="font-style: italic; font-size: 12px;"> {{teammate.role.name}} </span>
        <span style="color: #aaaaaa; font-style: italic; font-size: 12px;"> - {{teammate.user.email}} </span>
        <span v-if="teammate.is_invited" style="margin-left: 5px;" class="ui yellow mini label">Waiting </span>
        </span> 
      </p>
      <div v-show="teammate.visibleUsers" style="margin-bottom: 3px;" class="ui small label" v-for="visible in teammate.visibleUsers" :key="visible._id">
          {{visible.name}}
        </div>
    </div>
    <div style="border: none; min-width:250px;" class="ui segment right aligned">
        <button v-if="teammate.is_invited" @click="resendEmail(teammate)" class="ui mini orange basic button">Resend Invitation Email</button>
<!--         <button v-if="getRole.name == 'Admin'  && teammate.role.name != 'Admin' && getRole.name != 'Moderator'" @click="assignEvent(teammate)" style="background: transparent;" class="ui mini icon button">Set Permissions</button> -->

          <button v-if="getRole.name == 'Admin' && getRole.name != 'Moderator'" @click="assignEvent(teammate)" class="ui mini icon button">Set Permissions</button>
        <button v-if="getRole.name == 'Admin'  && workspaceusers.length != 1 && getRole.name != 'Moderator'" @click="deleteFromWorkspaceusers(teammate)" style="background: rgb(255, 239, 239);" class="ui mini icon button">
          <i class="trash icon"></i>
        </button>

    </div>
  </div>

  </div>


          <div v-if="show.teammateModal" class="ui basic delight segment">
          <div class="ui form">
          <div class="field">
            <label>Email</label>
            <input v-model="newTeammate.email" placeholder="joe@company.com" type="text" :disabled="loading.addTeammate">
          </div>
            <div class="field">
              <label>Roles</label>
              <select v-model="newTeammate.department.name" :disabled="loading.addTeammate">
                <option v-for="role in tagsByTypeName['Role']" :key="role._id" >{{role.name}}</option>
              </select>
              <div class="ui small info message">
                <div class="header">
                  Role Permissions
                </div>
                <ul class="list">
                  <li><b>Admin</b> can add/remove social accounts and see the statistics and performance of Moderator team.</li>
                  <li><b>Moderator</b> can only reach the social inbox and reply customer messages.</li>
                </ul>
              </div>
            </div>
          <button @click="addTeammate()" class="ui orange button fluid" v-bind:class="{ loading: loading.addTeammate }" :disabled="loading.two"> <i class="paper plane outline icon"></i> Send Invitation</button>
          </div>
          </div>
          <div v-show="getWhiteLabel" class="ui warning message">
            Please contact service provider in order to setup your team.
          </div>
          <div v-if="!show.teammateModal && getRole.name == 'Admin'" v-show="!getWhiteLabel" @click="show.teammateModal = true" class="ui small black button right floated"><i class="user plus icon"></i> Invite</div>
      </div>
      </div>
    </div>

  </div>

</template>

<style scoped>

.checkboxInput {
    margin: 0 0 10px;
    cursor: pointer;
}

.checkboxInput {
    display: -webkit-box;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    flex-direction: row;
    -webkit-box-align: center;
    align-items: center;
    cursor: pointer;
    -webkit-transition: all .1s ease-in-out;
    transition: all .1s ease-in-out;
}

.checkboxInput .checkbox {
    display: -webkit-box;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    min-width: 16px;
    width: 18px;
    height: 18px;
    border: 2px solid 
    #ddd;
    border-radius: 5px;
    -webkit-transition: all .1s ease-in-out;
    transition: all .1s ease-in-out;
    position:relative;
}

.checkboxInput .checkbox .icon-check {
    font-size: 10px;
    color: #aaa;
    opacity: 0;
    -webkit-transition: all .1s ease-in-out;
    transition: all .1s ease-in-out;
    -webkit-transform: translate(18%, -50%);
    transform: translate(-50%, -50%);
    position: absolute;
    left: 50%;
    bottom: 25%;
    height: 12px;
    top: 25%;
}
.checkboxInput .checkboxLabel {
    margin: 0 10px;
    font-size: 15px;
    line-height: 20px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    height: 22px;
}

.checkboxInput:hover .checkbox .icon-check {
    opacity: .3;
}

.checkboxInput .checkbox.checked .icon-check {
    color: #3960BD;
    opacity: 1;
}

.checkboxInput .checkbox.checked {
    border-color: #3960BD;
}

.modalWrapper {
   position: fixed; 
   top: 0; 
   right: 0; 
   bottom: 0; 
   left:0; 
   z-index: 9999; 
   overflow-x: hidden;
   overflow-y: scroll;
}
.modal {
   position: fixed; 
   top: 0; 
   right: 0; 
   bottom: 0; 
   left:0; 
   background: rgba(15, 17, 26, 0.35) none repeat scroll 0% 0%; 
   z-index: 9999; 
   overflow-x: hidden;
   overflow-y: scroll;
}

.radiusSegment {
  border-radius: 5px !important;
}

.cloud {
position: fixed;
background: rgba(0, 0, 0, 0.28) none repeat scroll 0% 0%;
left: 0px;
top: 0px;
bottom: 0px;
right: 0px;
z-index: 999;
}


.ui.icon.button > .icon, .ui.icon.buttons .button > .icon {
  opacity: .9;
  margin: 0 !important;
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Team.vue